export enum AllocationColumnTypes {INVESTMENT_TYPE='INVESTMENT_TYPE', CUSTOM_FIELD='CUSTOM_FIELD'}

export type AllocationColumn = {
    id?: string,
    label: string,
    index: number,
    code: string,
    transactionType: AllocationColumnTypes
};

export type TransactionColumn = {
    id?: string,
    label: string,
    index: number,
    allocationCode?: string,
    locked: boolean,
    transSubmitError: boolean,
    quarterNumber: number,
    transTypeId: string,
    isUserColumn: boolean,
    metricSign: number,
    useArkTransactionValues: boolean
};

export type Workbook = {
    id?: string,
    tenantId: string,
    fileName: string,
    fileType?: string,
    reportName: string,
    createdBy?: string,
    modifiedBy?: string,
    startQuarterYear: number,
    startQuarterNumber: number,
    dateCreated?: string,
    dateModified?: string,
    dateLastOpened?: string,
    type: string,
    frequency: string,
    decimalRounding: number,
    includeYtd: boolean,
    includeItd: boolean,
    lastRow: number,
    lastCol: string,
    fund: {
        id: string,
        name: string
    },
    allocationColumns: AllocationColumn[],
    transactionColumns: TransactionColumn[],
    commitmentTransactionTypeIds: string[]
};

export enum WorkbookSource {WorkbookInfoDialog, WorkbookRolloverWB}
export type WorkbookLocationState = {
    workbookSource: WorkbookSource,
    workbook: Workbook
}

export type InvestorCommitment = {
    investorId: string,
    investorType: string,
    investorName: string,
    totalTransactionAmount: number,
    transactionsDetails: [InvestorCommitmentTransactionDetail]
};

export type InvestorCommitmentTransactionDetail = {
    date: Date,
    amount: number
}

export type PitdSummaryValues = {
    investorId: string,
    investorName: string,
    investorType: string,
    totalTransactionAmount: number,
    transactionTotalMap: {
        [key: string]: number
    }
  };

export type SubmitToPcapTransaction = {
    name: string, 
    investor: string, 
    balance: number
}

export type GlEntry = {
    amount: number, 
    quarter: number, 
    year: number, 
    transactionTypeId: string
}

export enum PostingType {
    DEBIT = "DEBIT",
    CREDIT = "CREDIT"
}

export type LineItem = {
    name: string;
    accountId: string;
    amount: string | Number;
    postingType: PostingType;
    description: string;
    currency: string;
};

export type GLEntryV2 = {
    date: Date;
    adjustingEntry: boolean;
    memo: string | null; 
    lineItems: LineItem[];
}

export type GLEntryCreateParams = {
    fundId: string;
    entry: GLEntryV2;
};

export type TransactionTypeQuarterlySum = {
    transTypeId: string, 
    investorId: string, 
    sum: number
}


export type WorkbookLockStatus = {
    lockedAt: Date,
    lockedBy: string,
    locked: boolean
  };